import dateFormat from 'dateformat';

export const format = (date: string | Date, format: string): string => {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return dateFormat(date, format, true);
};

export const isoDateFormat = (date: string | Date): string => {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return dateFormat(date, 'isoDate', true);
};

export const formatFullDate = (date: string | Date) =>
  format(date, 'mmmm d, yyyy');

export const formatFullDateTime = (date: string | Date) =>
  format(date, 'mmmm d, yyyy "at" h:MM TT');

export const formatThreeLetterMonth = (date: string | Date) =>
  format(date, 'mmm"." d, yyyy');

export function buildDate(date?: string | null): Date | undefined {
  const object = date && new Date(date);
  return !!object && !isNaN(object.getTime()) ? object : undefined;
}

export function endOfDay(date: Date) {
  const end = new Date(date);
  end.setHours(23, 59, 59, 999);
  return end;
}
